import type {
	ExportCreateModel,
	ExportDownloadUrlModel,
	ExportModel,
	HTTPValidationError,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import type { ZodError } from 'zod'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

import { createExportSchema } from '../model/contract'

export function useCreateExportMutation(
	options?: UseMutationOptions<
		ExportModel,
		AxiosError<HTTPValidationError> | ZodError,
		ExportCreateModel
	>
) {
	return useMutation<
		ExportModel,
		AxiosError<HTTPValidationError> | ZodError,
		ExportCreateModel
	>({
		mutationFn: (body) =>
			client.export.createExport(createExportSchema.parse(body)),
		...(options || {}),
	})
}

export function useDeleteExportMutation(
	options?: UseMutationOptions<void, Error, string>
) {
	return useMutation<void, Error, string>({
		mutationFn: (exportId) => client.export.deleteExport({ exportId }),
		...(options || {}),
	})
}

export function useDownloadExportFileMutation(
	options?: UseMutationOptions<
		ExportDownloadUrlModel,
		AxiosError<HTTPValidationError>,
		string
	>
) {
	return useMutation<
		ExportDownloadUrlModel,
		AxiosError<HTTPValidationError>,
		string
	>({
		mutationFn: (exportId) => client.export.getDownloadLink({ exportId }),
		...(options || {}),
	})
}
